/** @jsx jsx */
import { Box, Flex, IconButton, jsx } from 'theme-ui'
import React, { useState } from 'react'
import Img from 'gatsby-image'
import { useModal } from 'react-modal-hook'
import Modal from '../Modal/Modal'
import theme from '../../../gatsby-plugin-theme-ui'
import chevronRight from '../../../icons/chevronRight.svg'
import chevronLeft from '../../../icons/chevronLeft.svg'
import styled from '@emotion/styled'

const Logo = styled.img`
  width: 12px;
`

const LightboxImage = ({ images, alt, ...rest }) => {
  const imageLength = images.length - 1
  const [currentImage, setCurrentImage] = useState(null)
  const [showModal, hideModal] = useModal(() => {
    function cycleArrayDown() {
      if (currentImage !== 0) {
        setCurrentImage(currentImage - 1)
      } else {
        setCurrentImage(imageLength)
      }
    }

    function cycleArrayUp() {
      if (currentImage !== imageLength) {
        setCurrentImage(currentImage + 1)
      } else {
        setCurrentImage(0)
      }
    }

    return (
      <Modal
        style={{
          overlay: { ...theme.modal.medium.overlay },
          content: {
            ...theme.modal.medium.content,
            background: 'transparent',
          },
        }}
        isOpen
        onRequestClose={hideModal}
        hideModal={hideModal}
      >
        <Flex style={{ alignItems: 'center' }}>
          <IconButton
            style={{ margin: 20, cursor: 'pointer' }}
            onClick={cycleArrayDown}
          >
            <Logo src={chevronLeft} />
          </IconButton>
          <Box style={{ flex: 1 }}>
            {images[currentImage] && (
              <Img
                style={{ height: '100%' }}
                imgStyle={{ objectFit: 'contain' }}
                fluid={images[currentImage].fluid}
                alt={`${alt} ${currentImage}`}
              />
            )}
          </Box>
          <IconButton
            style={{ margin: 20, cursor: 'pointer' }}
            onClick={cycleArrayUp}
          >
            <Logo src={chevronRight} />
          </IconButton>
        </Flex>
      </Modal>
    )
  }, [currentImage])
  return images.map((i, k) => (
    <Box
      key={k}
      onClick={() => {
        setCurrentImage(k)
        showModal()
      }}
    >
      <Img
        {...rest}
        alt={`${alt} ${currentImage}`}
        sx={{
          margin: 'auto',
          height: '120px',
          width: '150px',
        }}
        fluid={i.fluid}
      />
    </Box>
  ))
}

export default LightboxImage
